export default __webpack_public_path__ + "static/media/policia.bc257f93.png";